import React from 'react';
import { graphql } from 'gatsby';
import {
  ShopLayout,
} from '../components/Layout';
import {
  ProductList,
} from '../components/shop';
import { isClient } from '../util/helpers';

const ShopCategory = (props) => {
  const {
    data: {
      site: {
        siteMetadata,
      },
      category: thisCategory,
      shop,
      categories,
    },
    location,
    pageContext,
  } = props;
  const {
    shopSlug,
    shopCategorySlug,
  } = siteMetadata;
  const {
    title,
    description,
    handle,
  } = thisCategory;
  const seoData = {
    metaTitle: `${title} | See Make Play Shop`,
    metaDescription: description,
    banner: '',
  };
  if (isClient) document.documentElement.style.setProperty('--bg-colour', '#FFFFF4');
  const pathPrefix = `/${shopSlug}/${shopCategorySlug}/${handle}`;
  const productItems = shop && shop.edges.map(product => product.node);
  const categoryItems = categories && categories.edges.map(category => category.node);
  return (
    <ShopLayout location={location} seoData={seoData}>
      <ProductList
        products={productItems}
        categories={categoryItems}
        siteMetadata={siteMetadata}
        location={location}
        pageContext={pageContext}
        pathPrefix={pathPrefix}
      />
    </ShopLayout>
  );
};

export default ShopCategory;

export const pageQuery = graphql`
  query ShopCategoryPageQuery(
    $handle: String!,
    $shopCategoryItems: [String],
    $limit: Int!,
    $skip: Int!,
  ) {
    site {
      siteMetadata {
        shopSlug,
        shopCategorySlug,
      }
    },
    category: shopifyCollection(handle: { eq: $handle }) {
      handle
      description
      title
    }
    categories: allShopifyCollection {
      edges {
        node {
          handle
          title
        }
      }
    }
    shop: allShopifyProduct(
      sort: { fields: [createdAt], order: DESC }
      filter: { handle: { in: $shopCategoryItems } }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          title
          handle
          createdAt
          images {
            id
            originalSrc
            localFile {
              childImageSharp {
                fluid(maxWidth: 910) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          variants {
            price
          }
        }
      }
    }
  }
`;
